import { BehaviorParameters } from 'rangeConfig/@types';
import { ErrorMessages } from '@inter-ikea-storageone/range';
import {
  hideSmastadAllFramesIncludedDoorsErrorMessage,
  hideSmastadMixedFramesIncludedDoorsErrorMessage
} from 'rangeConfig/smastad/rules/hideMenuRules';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';
import changeFrontBehaviour from 'rangeConfig/shared/behaviors/changeFront';

const changeSmastadFrontBehavior = ({
  coreApi,
  dispatch,
  props,
  rootState
}: BehaviorParameters) => {
  const determinePlacementAttemptErrorMessage = () => {
    if (!hideNoFramesInSceneErrorMessage(coreApi)) {
      return ErrorMessages.NoFramesInScene;
    } else if (!hideSmastadAllFramesIncludedDoorsErrorMessage(coreApi)) {
      return ErrorMessages.SmastadAddingToFramesWithIncludedDoors;
    } else if (!hideSmastadMixedFramesIncludedDoorsErrorMessage(coreApi)) {
      return ErrorMessages.SmastadAddingToMixedFramesWithIncludedDoors;
    }
    return null;
  };
  const placementAttemptErrorMessage = determinePlacementAttemptErrorMessage();
  if (placementAttemptErrorMessage) {
    coreApi.emit.onPlacementAttempt(placementAttemptErrorMessage);
  }

  changeFrontBehaviour({ coreApi, dispatch, props, rootState });
};

export default changeSmastadFrontBehavior;
